import React, { useState, useEffect } from 'react'

import Navbar from '../../Components/Navbar/Navbar'
import { 
    Layout,
    Col, 
    Row,
    Table,
    Space,
    Button,
} from 'antd';

import { UseGetRequest } from '../../Utils/api/ApiRequests'
// import { usePostRequest } from '../../hooks/usePostRequest'
// import { formatDate } from '../../Utils/Common';
import { 
  ProductOutlined 
} from '@ant-design/icons';
import { 
  ArrowBack,
} from '@mui/icons-material';
import { 
  useNavigate, 
  useParams 
} from "react-router-dom"
import toast from 'react-hot-toast';

const FunGolfViewSummary = () => {
  const navigate = useNavigate()
  const { id } = useParams()
  // const [isLoading, setIsLoading] = useState(false);
  // const [pageSize, setPageSize] = useState('');

  const [filterConfig, setFilterConfig] = useState({
    tournament_id: id,
    // employee_id: '',
    // page: 1,
  })
  const [isLoading, setIsLoading] = useState(false);
  const [summaryData, setSummaryData] = useState([])
  // const [excelLink, setExcelLink] = useState('')

  const customSpinner = <ProductOutlined style={{ fontSize: 24 }} spin />;

  async function fetchPlayerData() {
    setIsLoading(true)
    const response = await UseGetRequest("fun_golf_scores/get", filterConfig);
    if (response?.data) {
      setSummaryData(response?.data?.data);
    } else {
      setSummaryData([])
    }

    setIsLoading(false);
  }

  async function fetchExportExcel() {
    setIsLoading(true)
    const response = await UseGetRequest("fun_golf_scores/get_excel_report", {tournament_id: id});
    if (response?.data) {
      const link = document.createElement('a');
      link.href = response.data.url;
      link.setAttribute('download', 'file.xlsx'); // You can specify the file name
      document.body.appendChild(link);
      link.click();
      link.remove();
    } else {
      toast.error(response?.data?.message)
    }
    setIsLoading(false);
  }

  const columns = [
    {
      title: 'PLAYER',
      dataIndex: 'player_name',
      key: 'player_name',
      align: 'center',
      render: (text) => <span style={{ fontWeight: 'bold' }}>{text}</span>, // Bold text
      // sorter: (a, b) => a.player_name.localeCompare(b.player_name),
    },
    {
      title: 'DIVISION',
      dataIndex: 'division_name',
      key: 'division_name',
      align: 'center',
      // sorter: (a, b) => a.division_name.localeCompare(b.division_name),
    },
    {
      title: 'HDC',
      dataIndex: 'hdc',
      key: 'hdc',
      align: 'center',
      // sorter: (a, b) => a.hdc.localeCompare(b.hdc),
    },
    {
      title: 'OUT',
      dataIndex: 'gross_out',
      key: 'gross_out',
      align: 'center',
      // sorter: (a, b) => a.gross_out.localeCompare(b.gross_out),
    },
    {
      title: 'IN',
      dataIndex: 'gross_in',
      key: 'gross_in',
      align: 'center',
      // sorter: (a, b) => a.gross_in.localeCompare(b.gross_in),
    },
    {
      title: 'GROSS',
      dataIndex: 'gross',
      key: 'gross',
      align: 'center',
      onHeaderCell: () => ({
        style: { backgroundColor: 'rgb(210, 241, 210)' },
      }),
      // sorter: (a, b) => a.gross.localeCompare(b.gross),
    },
    {
      title: 'OUT',
      dataIndex: 'net_out',
      key: 'net_out',
      align: 'center',
      // sorter: (a, b) => a.net_out.localeCompare(b.net_out),
    },
    {
      title: 'IN',
      dataIndex: 'net_in',
      key: 'net_in',
      align: 'center',
      // sorter: (a, b) => a.net_in.localeCompare(b.net_in),
    },
    {
      title: 'NET',
      dataIndex: 'net',
      key: 'net',
      align: 'center',
      onHeaderCell: () => ({
        style: { backgroundColor: 'rgb(241, 222, 207)' },
      }),
      // sorter: (a, b) => a.net.localeCompare(b.net),
    },
    {
      title: 'OUT',
      dataIndex: 'points_out',
      key: 'points_out',
      align: 'center',
      // sorter: (a, b) => a.points_out.localeCompare(b.points_out),
    },
    {
      title: 'IN',
      dataIndex: 'points_in',
      key: 'points_in',
      align: 'center',
      // sorter: (a, b) => a.points_in.localeCompare(b.points_in),
    },
    {
      title: 'POINTS',
      dataIndex: 'points',
      key: 'points',
      align: 'center',
      onHeaderCell: () => ({
        style: { backgroundColor: 'rgb(231, 210, 241) ' },
      }),
      // sorter: (a, b) => a.points.localeCompare(b.points),
    },
  ];

  const handleTableChange = (pagination) => {
    setFilterConfig((prev) => ({
      ...prev,
      page: parseInt(pagination.current),
      // total_records_per_page: pagination.pageSize,
    }));
  };

  useEffect(() => {
    fetchPlayerData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterConfig]);

  return (
    <Layout className='page'>
      <Navbar navKey={'invitational_nav'}/>
      <Layout className='content-container overflow-y'>
        <Row className='custom-padding responsive-tab-inline'>
          <Col span={12} >
            <Space className='header-container'>
              <ArrowBack className='cursor' onClick={() => navigate('/fun-golf/player/' + id)}/>
              FUN GOLF SUMMARY
            </Space>
          </Col>
          <Col span={12} align='right' className='p-2'>
            <Button 
              className='excel-btn' 
              size="large"
              onClick={fetchExportExcel}
            >
              Export To Excel
            </Button>
          </Col>
        </Row>
        <Row className='page-content'>
          <Col span={24} className='responsive-overflow-auto'>
          <Table 
            columns={columns} 
            dataSource={summaryData} 
            loading={{
              indicator: customSpinner,
              spinning: isLoading,
            }}
            pagination={false}
            onChange={handleTableChange}
            rowClassName='summary-table'
            className='summary-table-container'
            // onRow={(record, rowIndex) => {
            //   return {
            //     className: 'cursor',
            //     onClick: () => navigate('/fun-golf/player/' + record.id),
            //   };
            // }}
          />
          </Col>
        </Row>
      </Layout>
    </Layout>
  )
}

export default FunGolfViewSummary
